import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useSearchParams } from 'react-router-dom';
import CaracteristicasPage from './CaracteristicasPage';
import ModelosTextoPage from './ModelosTextoPage';
import ContasBancariasPanel from './ContasBancariasPanel';
import BiDashboardPage from './BiDashboardPage';
import './PerfilPage.css';

export default function ConfiguracoesPage() {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialIndex =
    tabParam === 'modelos' ? 1 : tabParam === 'contas' ? 2 : tabParam === 'bi' ? 3 : 0;
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  return (
    <div className="config-page">
      <h1>Configurações</h1>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="config-tabs">
        <TabPanel header="Características NFS-e">
          <CaracteristicasPage embedded />
        </TabPanel>
        <TabPanel header="Modelos de texto">
          <ModelosTextoPage embedded />
        </TabPanel>
        <TabPanel header="Contas bancárias">
          <ContasBancariasPanel embedded />
        </TabPanel>
        <TabPanel header="BI">
          <BiDashboardPage embedded />
        </TabPanel>
      </TabView>
    </div>
  );
}
